import { useEffect, type ReactNode } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useCustomerSession } from '../../lib/auth/customerSession'

/**
 * Renders `children` for a signed-in customer. Picks up a session left in this
 * tab first (reload, return from Stripe); anyone else goes to the sign-in page,
 * which brings them back here afterwards (`?next=`).
 */
export default function RequireCustomer({ children }: { children: ReactNode }) {
  const { lang = 'da' } = useParams<{ lang: string }>()
  const location = useLocation()
  const status = useCustomerSession((s) => s.status)
  const restore = useCustomerSession((s) => s.restore)

  useEffect(() => {
    void restore()
  }, [restore])

  if (status === 'restoring') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" role="status">
        <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }
  if (status === 'signedOut') {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/${lang}/account?next=${next}`} replace />
  }
  return <>{children}</>
}
